import { memo, useEffect, useRef, useState } from 'react';

/* eslint-disable max-len */
function BunnyFace() {
  return (
    <svg viewBox="0 0 512.001 512.001" width="96" height="96" style={{ display: 'block' }} aria-hidden="true">
      {/* Body */}
      <ellipse fill="#D6CABB" cx="255.748" cy="419.184" rx="101.834" ry="84.862" />
      {/* Head */}
      <circle fill="#F1EDE8" cx="255.748" cy="360.311" r="76.376" />
      <path fill="#E3DCD2" d="M272.979,427.666c-42.182,0-76.376-34.195-76.376-76.376c0-25.951,12.953-48.862,32.736-62.665c-29.164,10.75-49.964,38.785-49.964,71.682c0,42.181,34.194,76.376,76.376,76.376c16.231,0,31.267-5.078,43.64-13.711C291.159,426.006,282.264,427.666,272.979,427.666z" />
      {/* Ears */}
      <g>
        <path fill="#F1EDE8" d="M290.982,130.342c-18.063,52.478-16.684,106.944,0.304,155.563c43.314-27.863,77.922-69.943,95.985-122.421S403.956,56.54,386.967,7.921C343.654,35.786,309.045,77.866,290.982,130.342z" />
        <path fill="#F1EDE8" d="M221.03,130.342c18.063,52.478,16.684,106.944-0.304,155.563c-43.314-27.863-77.922-69.943-95.985-122.421S108.057,56.542,125.045,7.923C168.359,35.786,202.967,77.866,221.03,130.342z" />
      </g>
      {/* Ear inner colour */}
      <path fill="#FFBDC7" d="M219.161,279.13c5.813-34.54,2.887-69.836-8.782-103.742c-11.671-33.907-31.089-63.527-56.929-87.17c-5.813,34.54-2.887,69.836,8.782,103.742C173.903,225.865,193.322,255.485,219.161,279.13z" />
      <path fill="#F36280" d="M182.826,204.716c-10.808-31.402-14.101-63.998-9.912-96.081c-6.009-7.214-12.495-14.04-19.464-20.418c-5.813,34.54-2.887,69.836,8.782,103.742c11.671,33.906,31.089,63.526,56.929,87.17c0.43-2.55,0.796-5.104,1.13-7.662C204.021,251.937,191.35,229.476,182.826,204.716z" />
      <path fill="#FFBDC7" d="M292.851,279.13c-5.813-34.54-2.887-69.836,8.782-103.742c11.671-33.907,31.089-63.527,56.929-87.17c5.813,34.54,2.887,69.836-8.782,103.742C338.109,225.865,318.691,255.485,292.851,279.13z" />
      <path fill="#F36280" d="M329.186,204.716c10.808-31.402,14.101-63.998,9.912-96.081c6.009-7.214,12.495-14.04,19.464-20.418c5.813,34.54,2.887,69.836-8.782,103.742c-11.671,33.906-31.089,63.526-56.929,87.17c-0.43-2.55-0.796-5.104-1.13-7.662C307.992,251.937,320.663,229.476,329.186,204.716z" />
      {/* Paws */}
      <circle fill="#F1EDE8" cx="349.351" cy="427.67" r="59.403" />
      <path fill="#E3DCD2" d="M368.441,371.414c9.24,10.471,14.858,24.215,14.858,39.279c0,32.808-26.596,59.403-59.403,59.403c-6.68,0-13.094-1.119-19.087-3.152c10.885,12.335,26.802,20.124,44.545,20.124c32.808,0,59.403-26.596,59.403-59.403C408.758,401.538,391.882,379.366,368.441,371.414z" />
      <circle fill="#F1EDE8" cx="162.655" cy="427.67" r="59.403" />
      <path fill="#E3DCD2" d="M188.117,470.097c-32.808,0-59.403-26.596-59.403-59.403c0-15.064,5.618-28.807,14.858-39.279c-23.441,7.952-40.317,30.124-40.317,56.252c0,32.808,26.596,59.403,59.403,59.403c17.744,0,33.661-7.789,44.545-20.124C201.211,468.978,194.796,470.097,188.117,470.097z" />
      {/* Nose */}
      <circle fill="#FFBDC7" cx="256.003" cy="402.212" r="16.972" />
      {/* Teeth */}
      <polygon fill="#FFFFFF" points="272.979,478.583 281.73,436.152 230.548,436.152 239.034,478.583" />
      {/* Outlines */}
      <path d="M349.354,360.307c-3.157,0-6.258,0.234-9.3,0.657c0.005-0.396,0.028-0.792,0.028-1.187c0-29.748-15.497-55.928-38.828-70.945c23.13-15.788,43.189-35.193,59.679-57.777c2.59-3.548,1.814-8.525-1.734-11.116c-3.548-2.59-8.525-1.814-11.117,1.734c-2.18,2.986-4.434,5.904-6.747,8.77c6.288-11.328,11.631-23.297,15.967-35.893c12.132-35.249,15.196-71.468,9.105-107.651c-1.024-6.092-8.645-8.729-13.216-4.55c-27.071,24.77-46.948,55.203-59.08,90.451c-3.5,10.169-6.219,20.42-8.208,30.726c0.444-23.742,4.642-47.468,12.601-70.594c15.828-45.985,44.819-84.685,84.161-112.511c13.881,46.147,12.912,94.493-2.915,140.475c-2.275,6.609-4.871,13.176-7.716,19.519c-1.798,4.009-0.006,8.717,4.002,10.515c4.008,1.795,8.716,0.006,10.514-4.002c3.04-6.778,5.814-13.794,8.244-20.854C412.929,113.39,412.818,57.795,394.477,5.3c-1.669-4.773-7.551-6.809-11.815-4.066c-46.764,30.084-81.069,73.834-99.205,126.522c-17.066,49.584-17.968,101.742-2.728,151.469c-7.897-2.454-16.287-3.779-24.981-3.779c-8.489,0-16.685,1.274-24.419,3.618c15.189-49.679,14.27-101.779-2.778-151.309c-18.136-52.688-52.44-96.438-99.205-126.522c-4.263-2.743-10.146-0.708-11.815,4.066c-18.342,52.495-18.452,108.09-0.318,160.776c17.362,50.439,49.55,92.679,93.294,122.587c-23.478,14.989-39.092,41.255-39.092,71.114c0,0.373,0.011,0.747,0.016,1.121c-2.875-0.376-5.8-0.591-8.777-0.591c-6.939,0-13.783,1.052-20.344,3.129c-4.189,1.326-6.511,5.796-5.185,9.985c1.326,4.19,5.797,6.513,9.985,5.185c5.006-1.584,10.234-2.387,15.542-2.387c28.368,0,51.448,23.079,51.448,51.448s-23.079,51.448-51.448,51.448s-51.448-23.079-51.448-51.448c0-8.773,2.244-17.428,6.49-25.034c2.142-3.837,0.768-8.684-3.07-10.825c-3.833-2.142-8.682-0.768-10.824,3.069c-5.566,9.97-8.508,21.31-8.508,32.791c0,37.142,30.217,67.359,67.359,67.359c8.197,0,16.054-1.476,23.325-4.169c19.595,13.633,44.288,21.141,69.767,21.141c25.548,0,50.338-7.554,69.959-21.268c7.362,2.77,15.327,4.295,23.646,4.295c37.142,0,67.359-30.217,67.359-67.359S386.496,360.307,349.354,360.307z M309.156,177.977c9.511-27.632,24.138-52.062,43.576-72.821c2.543,28.325-0.964,56.582-10.475,84.214c-9.511,27.631-24.138,52.061-43.576,72.82C296.14,233.868,299.647,205.607,309.156,177.977z M169.755,189.37c-9.511-27.632-13.018-55.889-10.475-84.214c19.438,20.759,34.065,45.189,43.576,72.821c9.51,27.63,13.017,55.89,10.475,84.213C193.892,241.431,179.265,217.001,169.755,189.37z M129.348,20.421c39.342,27.826,68.333,66.528,84.161,112.511c7.96,23.129,12.159,46.854,12.602,70.599c-1.989-10.308-4.709-20.561-8.209-30.732c-12.133-35.249-32.01-65.68-59.08-90.451c-4.571-4.179-12.193-1.543-13.216,4.55c-6.091,36.183-3.027,72.402,9.105,107.651c4.391,12.757,9.811,24.872,16.204,36.327c-16.707-20.602-29.758-44.141-38.651-69.979C116.436,114.913,115.466,66.567,129.348,20.421z M187.56,365.098c-0.136-1.77-0.229-3.548-0.229-5.322c0-37.726,30.694-68.42,68.42-68.42s68.42,30.694,68.42,68.42c0,1.84-0.088,3.694-0.234,5.526c-23.169,9.478-39.911,31.499-41.752,57.578c-8.368,3.513-17.248,5.316-26.433,5.316c-8.985,0-17.687-1.728-25.905-5.096C228.07,396.732,211.061,374.485,187.56,365.098z M270.889,442.73l-4.65,27.897h-20.466l-4.633-27.802c4.79,0.836,9.664,1.282,14.61,1.282C260.88,444.108,265.931,443.628,270.889,442.73z M255.751,496.086c-19.287,0-37.986-4.883-53.665-13.856c11.01-7.978,19.518-19.195,24.116-32.248l4.985,29.909c0.641,3.837,3.959,6.648,7.848,6.648h33.945c3.889,0,7.208-2.811,7.847-6.648l4.986-29.91c4.567,12.965,12.989,24.12,23.891,32.088C293.964,491.146,275.144,496.086,255.751,496.086z M349.354,479.113c-28.368,0-51.448-23.079-51.448-51.448s23.079-51.448,51.448-51.448s51.448,23.079,51.448,51.448S377.723,479.113,349.354,479.113z" />
      <path d="M289.201,376.218c2.036,0,4.072-0.776,5.626-2.331l0.75-0.75c3.107-3.107,3.107-8.145,0-11.251c-3.108-3.107-8.145-3.107-11.252,0l-0.75,0.75c-3.107,3.107-3.107,8.145,0,11.251C285.129,375.441,287.165,376.218,289.201,376.218z" />
      <path d="M228.438,361.887c-3.108-3.107-8.145-3.107-11.252,0l-0.75,0.75c-3.107,3.107-3.107,8.145,0,11.251c1.554,1.553,3.591,2.331,5.626,2.331s4.072-0.776,5.626-2.331l0.75-0.75C231.544,370.031,231.544,364.993,228.438,361.887z" />
      <path d="M256.006,427.135c13.746,0,24.928-11.183,24.928-24.928c0-13.746-11.183-24.928-24.928-24.928c-13.746,0-24.928,11.183-24.928,24.928C231.078,415.953,242.261,427.135,256.006,427.135z M256.006,393.191c4.972,0,9.017,4.045,9.017,9.017s-4.045,9.017-9.017,9.017c-4.972,0-9.017-4.045-9.017-9.017S251.034,393.191,256.006,393.191z" />
    </svg>
  );
}
/* eslint-enable max-len */

const EGG_DURATION_MS = 1900;
const PEEK_DURATION_MS = () => 2000 + Math.random() * 2500;
const IDLE_MS = () => 1000 + Math.random() * 2000;
const randX = () => 5 + Math.random() * 82;

const EGG_COLORS = [
  { body: '#f9c6d0', stripe: '#f4a0b0' }, // pink
  { body: '#b5e4c8', stripe: '#7ecfa4' }, // mint green
  { body: '#b8d9f5', stripe: '#7eb8ee' }, // sky blue
  { body: '#f9e4a0', stripe: '#f0cc55' }, // yellow
  { body: '#d5b8f5', stripe: '#b58eee' }, // lavender
  { body: '#f5c98a', stripe: '#e8a84a' }, // peach/orange
];

function EggSvg({ color, dots }) {
  return (
    <svg viewBox="0 0 22 28" width="22" height="28" style={{ display: 'block' }} aria-hidden="true">
      <ellipse cx="11" cy="15" rx="10" ry="13" fill={color.body} />
      {dots ? (
        <>
          <circle cx="7" cy="10" r="1.5" fill={color.stripe} />
          <circle cx="14" cy="9" r="1.5" fill={color.stripe} />
          <circle cx="5" cy="16" r="1.5" fill={color.stripe} />
          <circle cx="12" cy="18" r="1.5" fill={color.stripe} />
          <circle cx="17" cy="14" r="1.5" fill={color.stripe} />
        </>
      ) : (
        <>
          <path d="M2,11 Q11,6 20,11" stroke={color.stripe} strokeWidth="2" fill="none" />
          <path d="M1,18 Q11,23 21,18" stroke={color.stripe} strokeWidth="2" fill="none" />
        </>
      )}
    </svg>
  );
}

/**
 * Easter decoration – a single coordinator runs one action at a time:
 * either the bunny peeks over the bottom edge OR an egg flies upward.
 * Only one is ever visible at any moment.
 */
function EasterAnimation() {
  // Bunny: always rendered so CSS transitions work; x & peeking drive its position
  const [bunny, setBunny] = useState({ x: 20, peeking: false });
  // Egg: keyed so each new throw restarts the CSS animation
  const [egg, setEgg] = useState(null); // { id, x } | null
  const timer = useRef(null);

  useEffect(() => {
    const after = (fn, ms) => {
      clearTimeout(timer.current);
      timer.current = setTimeout(fn, ms);
    };

    const runNext = () => {
      after(() => {
        if (Math.random() < 1 / 3) {
          // ── Bunny peek ──
          const x = randX();
          setBunny({ x, peeking: true });
          after(() => {
            setBunny((b) => ({ ...b, peeking: false }));
            after(runNext, 600); // wait for hide transition before next action
          }, PEEK_DURATION_MS());
        } else {
          // ── Egg throw ──
          const color = EGG_COLORS[Math.floor(Math.random() * EGG_COLORS.length)];
          setEgg({ id: Date.now(), x: randX(), color, dots: Math.random() < 0.5 });
          after(() => {
            setEgg(null);
            after(runNext, 200);
          }, EGG_DURATION_MS);
        }
      }, IDLE_MS());
    };

    after(runNext, 800);
    return () => clearTimeout(timer.current);
  }, []);

  return (
    <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 9999, overflow: 'hidden' }}>
      {/* Bunny – always in DOM so the CSS transition plays on peek/hide */}
      <div style={{ position: 'absolute', bottom: 0, left: `${bunny.x}%` }}>
        <div
          style={{
            transform: `translateY(${bunny.peeking ? '7%' : '120%'})`,
            transition: bunny.peeking
              ? 'transform 0.5s cubic-bezier(0.34, 1.5, 0.64, 1)'
              : 'transform 0.4s ease-in',
            pointerEvents: bunny.peeking ? 'auto' : 'none',
            cursor: 'none',
          }}
          onMouseEnter={() => setBunny((b) => ({ ...b, peeking: false }))}
        >
          <BunnyFace />
        </div>
      </div>

      {/* Egg – keyed so remounting restarts the animation on each new throw */}
      {egg && (
        <div
          key={egg.id}
          style={{
            position: 'absolute',
            bottom: 0,
            left: `${egg.x}%`,
            userSelect: 'none',
            animation: `eggThrow ${EGG_DURATION_MS}ms ease-in-out forwards`,
            transform: 'translateX(-50%)',
          }}
        >
          <EggSvg color={egg.color} dots={egg.dots} />
        </div>
      )}

      <style>{`
        @keyframes eggThrow {
          0%   { transform: translateX(-50%) translateY(0px)    rotate(0deg);   }
          40%  { transform: translateX(-50%) translateY(-165px) rotate(180deg); }
          100% { transform: translateX(-50%) translateY(60px)   rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default memo(EasterAnimation);

